import { getEnv, isDev } from "../../AppConfigs";
import { getUCTDate } from "../../helper/dateTimeHelper";
import { DriveItem } from "../../models";
import api from "../axiosBase";
import axios from "../department-viags/config.service";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SP_DOCUMENT_LIBRARY_ID = getEnv("REACT_APP_FOLDER_AND_FILE_SP_LIST_ID");
const SP_PUBLISH_DOCUMENT_LIBRARY_ID = getEnv("REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_LIST_ID");
const SP_PUBLISH_DOCUMENT_INFO_LIST_ID = getEnv("REACT_APP_WORKING_DOCS_PUBLISH_INF_LIST_ID");

export const DocumentApiV2 = {
  //Using for public document tree
  async getDocumentsDirectory(isPublish: boolean = false): Promise<any[]> {
    const listId = isPublish ? SP_PUBLISH_DOCUMENT_LIBRARY_ID : SP_DOCUMENT_LIBRARY_ID;
    const contentType = !isDev ? "Folder" : "Thư mục";
    const filter = `fields/ContentType eq '${contentType}'`;

    const headers = {
      "Content-Type": "application/json",
      Prefer: "HonorNonIndexedQueriesWarningMayFailRandomly",
    };

    // Initial query
    let nextLink = `/sites/${SPSiteId}/lists/${listId}/items?$expand=fields($select=docPosition),driveItem&$filter=${filter}&$top=3000`;

    let allItems: any[] = [];

    while (nextLink) {
      const response = await api.get(`https://graph.microsoft.com/v1.0${nextLink}`, { headers });
      const data = response.data;

      allItems.push(...(data.value || []));

      nextLink = data["@odata.nextLink"]
        ? data["@odata.nextLink"].replace("https://graph.microsoft.com/v1.0", "")
        : null;
    }

    return allItems;
  },
  //Using for document manager
  async getDocumentsMgmtDirectory(isPublish: boolean = false): Promise<{ value: any[] } | { driveItem: DriveItem }[]> {
    const listId = isPublish ? SP_PUBLISH_DOCUMENT_LIBRARY_ID : SP_DOCUMENT_LIBRARY_ID;
    const filter = !isDev ? "fields/ContentType eq 'Folder'" : "fields/ContentType eq 'Thư mục'";

    const startDate1 = getUCTDate(new Date("2020-07-01T00:00:00Z"));
    const endDate1 = isPublish
      ? getUCTDate(new Date("2024-08-16:14:40:00Z"))
      : getUCTDate(new Date("2024-08-23:04:00:00Z"));
    const res1 = `/sites/${SPSiteId}/lists/${listId}/items?$expand=fields,driveItem&$filter=(fields/Created ge '${startDate1}' and fields/Created le '${endDate1}' and ${filter})&$top=2500`;

    const startDate2 = isPublish
      ? getUCTDate(new Date("2024-08-16:14:40:01Z"))
      : getUCTDate(new Date("2024-08-23:04:00:01Z"));
    const endDate2 = isPublish
      ? getUCTDate(new Date("2024-08-16:15:00:00Z"))
      : getUCTDate(new Date("2024-08-23:04:26:00Z"));
    const res2 = `/sites/${SPSiteId}/lists/${listId}/items?$expand=fields,driveItem&$filter=(fields/Created ge '${startDate2}' and fields/Created le '${endDate2}' and ${filter})&$top=2500`;

    const startDate3 = isPublish
      ? getUCTDate(new Date("2024-08-16:15:00:01Z"))
      : getUCTDate(new Date("2024-08-23:04:26:01Z"));
    const endDate3 = isPublish
      ? getUCTDate(new Date("2024-08-16:15:58:00Z"))
      : getUCTDate(new Date("2024-08-23:04:30:00Z"));
    const res3 = `/sites/${SPSiteId}/lists/${listId}/items?$expand=fields,driveItem&$filter=(fields/Created ge '${startDate3}' and fields/Created le '${endDate3}' and ${filter})&$top=2500`;

    const startDate4 = isPublish
      ? getUCTDate(new Date("2024-08-16:15:58:01Z"))
      : getUCTDate(new Date("2024-08-23:04:30:01Z"));
    const endDate4 = getUCTDate(new Date(new Date().setSeconds(new Date().getSeconds() + 10)));

    const res4 = `/sites/${SPSiteId}/lists/${listId}/items?$expand=fields,driveItem&$filter=(fields/Created ge '${startDate4}' and fields/Created le '${endDate4}' and ${filter})&$top=2500`;

    const request = {
      requests: [
        {
          id: "1",
          method: "GET",
          url: res1,

          headers: { "Content-Type": "application/json", Prefer: "HonorNonIndexedQueriesWarningMayFailRandomly" },
        },
        {
          id: "2",
          method: "GET",
          url: res2,
          headers: { "Content-Type": "application/json", Prefer: "HonorNonIndexedQueriesWarningMayFailRandomly" },
        },
        {
          id: "3",
          method: "GET",
          headers: { "Content-Type": "application/json", Prefer: "HonorNonIndexedQueriesWarningMayFailRandomly" },
          url: res3,
        },
        {
          id: "4",
          method: "GET",
          headers: { "Content-Type": "application/json", Prefer: "HonorNonIndexedQueriesWarningMayFailRandomly" },
          url: res4,
        },
      ],
    };

    const batchResponse = await api.post("https://graph.microsoft.com/v1.0/$batch", request);

    const finalRes = batchResponse?.data?.responses.reduce((acc: any, curr: any) => {
      const value = curr?.body?.value || [];
      return [...acc, ...value];
    }, []);

    return finalRes;
  },
  async getDocumentsMgmtDirectoryNew(): Promise<{ value: any[] } | { driveItem: DriveItem }[]> {
    const response = await axios.get("/edoc/get-public-document-tree");

    return response.data;
  },
  async getDocumentsTreeNew() {
    const response = await axios.get("/edoc/get-document-tree");

    return response.data;
  },
  getItem(itemId: string, option?: { queryString?: string }, isPublish: boolean = false): Promise<any> {
    const listId = isPublish ? SP_PUBLISH_DOCUMENT_LIBRARY_ID : SP_DOCUMENT_LIBRARY_ID;
    const queryString = option?.queryString ?? "$expand=listItem($expand=fields)";
    return api.get(
      `https://graph.microsoft.com/v1.0/sites/${SPSiteId}/lists/${listId}/drive/items/${itemId}?${queryString}`,
    );
  },
  async getRecentPublishDoc(): Promise<{ value: any[] } | { driveItem: DriveItem }[]> {
    const listId = SP_PUBLISH_DOCUMENT_INFO_LIST_ID;
    const pageSize = 1000;

    const expand =
      "&expand=fields(select=Title,docWorkingId,workingFileId,docStatusId,IsConvertToPDF,IsCustomEditor,docStatusValue,subInfo,docStatus,docNotes,effectiveFrom,effectiveTo,docId,publishDate,publishVersion,publishViewVersion,docUrl,docLinks,chatGroupId,chatGroupName,docTypeLookupId,docType,docAssignedTo,docSharedTo,docEditors,docReviewers,docDetectors,docCheckers,docPublicEndUsers,approvedBy, approvedName, approvedDate,fileId,fileAssignedTo,docPublicVersion,docEditionVersion,docPublishViewVersion,docPublicDepartment,docPublicDepartmentLookupId,docCode,Tags,docOrder,docAreas, docReaders,isMigrate, Modified,docEditTemp, fileAttachment, isContentPermission)";

    let url = `https://graph.microsoft.com/v1.0/sites/${SPSiteId}/lists/${listId}/items?${expand}&$filter=fields/docId ge 32600&$orderby=id desc&$top=${pageSize}`;

    let allItems: any[] = [];

    while (url) {
      const response = await api.get(url);
      const items = response?.data.value || [];
      allItems = [...allItems, ...items];

      // Check for nextLink to see if there's more data
      url = response.data["@odata.nextLink"] || null;
    }

    return allItems;
  },
};
